export default __webpack_public_path__ + "static/media/e2Õëì75Õ║ª-RGBõ║ñþëç.302f894c.jpg";